import React from "react";
import { motion } from "framer-motion";

const Left = () => {
  return (
    <div className="flex flex-col items-start justify-center flex-1 gap-3 py-2">
      <p className="text-[2rem] lg:text-[4rem] font-extrabold tracking-wide text-headingColor">
        CÔNG TY TNHH MTV THỰC PHẨM
        <span className="text-orange-600 text-[2.5rem] lg:text-[4.6rem]">
          {" "}
          Giai Giai
        </span>
      </p>
      <p className="text-base text-textColor text-center md:text-left md:w-[80%]">
        Với sứ mệnh mang đến hương vị thơm ngon và dinh dưỡng cho mọi gia đình,
        chúng tôi luôn chú trọng đến nguyên liệu tự nhiên, quy trình sản xuất
        hiện đại và an toàn thực phẩm. Đội ngũ nhân viên giàu kinh nghiệm kết
        hợp cùng công nghệ hiện đại tạo nên những sản phẩm thơm ngon, hấp dẫn,
        phù hợp với mọi lứa tuổi.
      </p>
      <motion.a
        whileHover={{ scale: 1.1 }}
        className="w-full px-4 py-2 mt-2 text-center text-white transition-all duration-100 ease-in-out rounded-lg bg-gradient-to-br from-orange-400 to-orange-500 md:w-auto hover:shadow-lg"
        href={"tel:0369980580"}
      >
        Liên hệ ngay
      </motion.a>
    </div>
  );
};

export default Left;
